import { useQuery } from "@tanstack/react-query";

import * as types from "types";
import useGetAccessToken from "components/Login/useGetAccessToken";
import { downloadFile, downloadLegacyFile } from "../methods/downloadFile";

type UseFileUrlOptions = {
  chatThread: types.ChatThread;
  fileName: string;
  permalink?: string | null;
};

export default function useDownloadFile({
  chatThread,
  fileName,
  permalink,
}: UseFileUrlOptions) {
  const chatId = chatThread.id;
  const queryKey = ["ctvaChain", "downloadFile", chatId, fileName, permalink];

  const getAccessToken = useGetAccessToken();
  const query = useQuery({
    queryKey,
    queryFn: () => {
      if (!permalink) {
        return downloadLegacyFile(fileName, chatId, getAccessToken);
      }
      return downloadFile(permalink, getAccessToken);
    },
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: Infinity,
  });

  return query;
}
